/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import moment from 'moment';
import BoxSearchFlignhts from '@/componentWebs/vietnamTickets/BoxSearchFlignhts'
import { stringify } from 'qs';
import router from 'next/router'

const RenderTemplatesCategory = dynamic(() => import('@/GroupTemplate'), {
  ssr: true,
  loading: () => null,
});

const pageSize = 12;


moment.locale('vi')

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  state = {
    dataChildrenCategoryAll: [],
  };

  componentDidMount() {
    const { data, dispatch } = this.props;
    const query = {
      filter: {
        status: "1",
        parentId: data.id,
        // parentId: data.id,
        // sitesId: data.sitesId
      },
      range: [0, pageSize - 1],
      sort: ['orderBy', 'asc'],
    };
    dispatch({
      type: 'webs/fetchAllChildrenCategory',
      payload: query,
      callback: item => {
        const dataChildren = item && item.result && item.result.list;
        this.setState({
          dataChildrenCategoryAll: dataChildren || [],
        });
      },
    });
  }


  render() {
    const { data, dataSite } = this.props;
    const { dataChildrenCategoryAll } = this.state;

    const template =
      data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    const imageResize =
      template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;

    return (
      // Tin tức trang chủ
      <React.Fragment>
        <div>

          <section className="banner banner-vemaybay">
            <div className="container bodyMobile">
              <div className="banner_wrapper bannerMobile">
                <div className="banner_top">
                  <div className="banner_top-title">
                    <h2>
                      Vé máy bay giá rẻ
                    </h2>
                    <h1>
                      Bay ngay kẻo lỡ!
                    </h1>
                  </div>
                  <div className="banner_top-img hidden-m-t">
                    <img src="/static/vietnamTickets/images/Group 9316.svg" alt="banner-top-img" className='lazyload' width='auto' height="auto" />
                  </div>
                </div>
                <BoxSearchFlignhts typeTab="maybay" />
              </div>
            </div>
          </section>

          {dataChildrenCategoryAll && dataChildrenCategoryAll.length
            ? dataChildrenCategoryAll.map((item) => {
              const categoriesTemplateLayout = (item && item.categoriesTemplateLayout) || {};
              const pageTemplate =
                categoriesTemplateLayout &&
                categoriesTemplateLayout.length > 0 &&
                categoriesTemplateLayout.find(e => e && e.isHome === false);
              const modifedCategory = {
                ...item,
                templateLayouts: pageTemplate && pageTemplate.templateLayouts,
                isChildren: true
              };
              // console.log(modifedCategory);
              return (
                <RenderTemplatesCategory
                  data={[modifedCategory]}
                  dataSite={dataSite}
                  key={item.id}
                />
              );
            })
            : null}



          <div className="pagiTuyenBay-top hidden-pc" />

        </div>
      </React.Fragment>
    );
  }
}

export default Index;
